export const defaultProfileMapStyleUrl = "https://tiles.openfreemap.org/styles/liberty";

const disabledMapValues = new Set(["0", "false", "off", "disabled", "no"]);

function isLocalHttpMapStyleUrl(url: URL): boolean {
  return url.protocol === "http:" && ["localhost", "127.0.0.1"].includes(url.hostname);
}

function readMapEnabledEnv(): string | undefined {
  if (typeof process === "undefined") {
    return undefined;
  }
  return process.env.REACT_APP_PROFILE_SERVICE_AREA_MAP_ENABLED
    ?? process.env.NEXT_PUBLIC_PROFILE_SERVICE_AREA_MAP_ENABLED;
}

function readMapStyleEnv(): string | undefined {
  if (typeof process === "undefined") {
    return undefined;
  }
  return process.env.REACT_APP_PROFILE_SERVICE_AREA_MAP_STYLE_URL
    ?? process.env.NEXT_PUBLIC_PROFILE_SERVICE_AREA_MAP_STYLE_URL;
}

export function isProfileMapEnabled(rawValue?: string): boolean {
  const value = rawValue ?? readMapEnabledEnv();
  if (value === undefined) {
    return true;
  }
  return !disabledMapValues.has(value.trim().toLowerCase());
}

export function resolveProfileMapStyleUrl(rawValue?: string): string {
  const value = rawValue?.trim()
    || readMapStyleEnv()?.trim()
    || defaultProfileMapStyleUrl;
  if (value.startsWith("/")) {
    return value;
  }
  try {
    const url = new URL(value);
    if (url.protocol === "https:" || isLocalHttpMapStyleUrl(url)) {
      return url.toString();
    }
  } catch {
    return defaultProfileMapStyleUrl;
  }
  return defaultProfileMapStyleUrl;
}

/** @deprecated Use isProfileMapEnabled */
export const isProfileServiceAreaMapEnabled = isProfileMapEnabled;

/** @deprecated Use resolveProfileMapStyleUrl */
export const resolveProfileServiceAreaMapStyleUrl = resolveProfileMapStyleUrl;

export const defaultProfileServiceAreaMapStyleUrl = defaultProfileMapStyleUrl;
